<template>
  <label
    :class="{ active: modelValue, 'cursor-pointer': !disabled, size }"
    class="inline-flex items-center align-middle text-inherit"
  >
    <input type="checkbox" :checked="!!modelValue" :disabled="disabled" @change="onChange()" class="hidden" />
    <span class="toggle__switch" :class="{ '--small': size === 'small' }"></span>
    <span v-if="showText" class="ml-2">{{ modelValue ? activeText || $t('labels.active') : inactiveText || $t('labels.inactive') }}</span>
  </label>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  size?: string
  modelValue?: boolean | number
  disabled?: boolean
  showText?: boolean
  activeText?: string
  inactiveText?: string
  beforeChange?: any
  activeColor?: string
}>()

const emit = defineEmits(['update:modelValue'])
const color = computed(() => props.activeColor || '#3B82F6')

const onChange = () => {
  if (typeof props.beforeChange === 'function') {
    Promise.resolve(props.beforeChange())
      .then((result) => {
        if (result) emit('update:modelValue', !props.modelValue)
      })
      .catch(() => {})
  } else {
    emit('update:modelValue', !props.modelValue)
  }
}
</script>

<style lang="scss" scoped>
.toggle__switch {
  @apply relative inline-block h-5 w-10 rounded-3xl border border-solid border-black/60 dark:border-white/60 bg-transparent transition-all;
  &.--small {
    @apply scale-75;
  }

  &::after {
    @apply absolute left-[2px] top-[2px] block h-[14px] w-[14px] rounded-full border border-solid border-black/60 dark:border-white/60 bg-white dark:bg-white/80 transition-all;
    content: '';
    transition: all 0.25s cubic-bezier(0.5, -0.6, 0.5, 1.6);
  }
}

.active {
  .toggle__switch {
    background-color: v-bind(color);
    border-color: v-bind(color);

    &::after {
      @apply left-[22px] border-white bg-white;
    }
  }
}
</style>
